module.exports = __webpack_public_path__ + "static/media/zuikaku-win.364524f4.png";